import React from 'react'

interface StatCardProps {
  icon: React.ReactNode
  label: string
  value: string | number
  change?: {
    value: number
    isPositive: boolean
  }
  className?: string
}

export default function StatCard({
  icon,
  label,
  value,
  change,
  className = '',
}: StatCardProps) {
  return (
    <div
      className={`bg-white rounded-xl shadow-md border border-gray-200 p-3 sm:p-6 hover:shadow-lg transition-shadow ${className}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs sm:text-sm font-medium text-gray-600">{label}</p>
          <p className="text-xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{value}</p>
          {change && (
            <p
              className={`text-xs sm:text-sm font-medium mt-1 sm:mt-2 ${
                change.isPositive ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {change.isPositive ? '+' : '-'} {Math.abs(change.value)}% vs last month
            </p>
          )}
        </div>
        <div className="bg-linear-to-br from-blue-50 to-indigo-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
          {icon}
        </div>
      </div>
    </div>
  )
}
